// 시간축 눈금 글자의 공통 손질. TimeChart·RangeChart 가 같이 쓴다 — 두 판의 축이 같은 규칙으로
// 글자를 빼야 한 화면에 둘이 있을 때 한쪽만 끝 글자가 잘린 채 남지 않는다.
import uPlot from 'uplot'
import { labelFits } from './model.js'

// edgeSafe 는 판 오른쪽 끝에서 잘릴 눈금 글자를 뺀다(model.js 의 labelFits). 눈금 글자는
// 눈금 가운데에 앉아서 끝에 붙은 눈금은 반이 판 밖으로 나가 잘린다 — 잘린 「09.30 00:」 는
// 틀린 시각처럼 읽히므로 아예 안 적는다. 선은 그대로 둔다.
export function edgeSafe(values) {
  return (u, splits, ...rest) => {
    const out = values(u, splits, ...rest)
    // 판 폭은 uPlot 이 계산해 둔 bbox(device px)에서 읽는다. u.over 의 DOM 폭은 처음 그릴 때
    // 아직 0 이라, 그걸 보면 첫 화면에서만 끝 글자가 잘린 채 남는다(확대하면 사라졌다).
    const right = u.bbox.width / (uPlot.pxRatio || 1)
    return out.map((s, i) => (!s || !(right > 0) || labelFits(u.valToPos(splits[i], 'x'), s, right) ? s : ''))
  }
}
